export function normalizeText(value: any): string {
  return value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

export function extractBankCode(bank: any): string | null {
  if (!bank) {
    return null;
  }

  if (typeof bank === 'string' || typeof bank === 'number') {
    const cleaned = bank.toString().trim();
    return cleaned ? cleaned.toUpperCase() : null;
  }

  if (typeof bank === 'object') {
    const metadata = parseMetadata(bank.metadata);
    const primary =
      bank.id ??
      bank.code ??
      bank.value ??
      bank.bank_code ??
      bank.bankCode ??
      metadata?.['code'] ??
      metadata?.['bank_code'] ??
      metadata?.['bankCode'];

    if (primary != null && `${primary}`.trim().length) {
      return `${primary}`.trim();
    }

    const fallback =
      bank.shortname ??
      bank.name ??
      bank.label ??
      metadata?.['shortname'] ??
      metadata?.['name'];

    if (fallback != null && `${fallback}`.trim().length) {
      return normalizeText(fallback).replace(/\s+/g, '_').toUpperCase();
    }
  }

  return null;
}

export function extractBankName(bank: any): string {
  if (!bank) {
    return '';
  }

  if (typeof bank === 'string') {
    return bank.trim();
  }

  if (typeof bank === 'object') {
    const metadata = parseMetadata(bank.metadata);
    const candidates = [
      bank.name,
      bank.shortname,
      bank.label,
      bank.title,
      bank.description,
      metadata?.['name'],
      metadata?.['shortname'],
      metadata?.['label'],
    ];

    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.trim().length) {
        return candidate.trim();
      }
    }
  }

  return '';
}

export function toTitleCase(text: string): string {
  if (!text) {
    return '';
  }

  return text
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function parseMetadata(raw: unknown): Record<string, any> | null {
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    return raw as Record<string, any>;
  }

  if (typeof raw !== 'string' || !raw.trim()) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : null;
  } catch {
    return null;
  }
}
